<template>
  <div id="app">
    <router-view v-if="showCard"></router-view>
  </div>
</template>
<script>
import { apiGet } from "./assets/http";
import { Loading } from "element-ui";
let loading = Loading.service({
  lock: true,
  fullscreen: true,
  text: "Loading...",
  // spinner: "el-icon-loading",
  background: "#FFF",
});
export default {
  data() {
    return {
      loading,
      windowWidth: null,
      showCard:false,
    };
  },
  watch: {
    windowWidth(val) {
      let that = this;
      console.log("实时屏幕高度：", val, that.windowWidth);
      if (val < 1200) {
        document.getElementById("app").style.zoom = "0.8";
      } else {
        document.getElementById("app").style.zoom = "1";
      }
    },
  },
  created() {
    this.startLoading();
    apiGet("/business/web/getDictData", { key: "sys_company" }).then((res) => {
      if(res && res.data){
        sessionStorage.setItem("companyLink", JSON.stringify(res.data));
      }
    });
    apiGet("/business/web/getSysConfig", { key: "sys.name" }).then((res) => {
      if(res && res.data){
        sessionStorage.setItem("headerTitle", res.data.value);
        document.title = res.data.value;
      }
    });
    const industryConfig = JSON.parse(sessionStorage.getItem("industryConfig"));
    console.log(industryConfig);
    if (!industryConfig) {
      console.log("改变了");
      apiGet("/business/web/getIndustryConfig", {}).then((res) => {
        if (res.data) {
          let obj = {
            industryConfigType: 1,
            industryConfigId: res.data[0].industryConfigId,
            industryConfigIdList: [res.data[0].industryConfigId],
            name: [res.data[0].name],
          };
          sessionStorage.setItem(
            "industryConfigList",
            JSON.stringify(res.data)
          );
          sessionStorage.setItem("industryConfig", JSON.stringify(obj));
          console.log(res.data);
          this.showCard = true;
          loading.close();
        }
      });
    } else {
      this.showCard = true;
      console.log("没改变");
      loading.close();
    }
  },
  mounted() {
    this.windowWidth = document.documentElement.clientWidth;
    window.onresize = () => {
      //屏幕尺寸变化
      return (() => {
        this.windowWidth = document.documentElement.clientWidth;
      })();
    };
    //  /*浏览器标签页切换会触发"visibilitychange"事件*/
    // document.addEventListener("visibilitychange", event => {
    //   console.log(document.visibilityState)
    //   console.log(event)
    //   if (document.visibilityState === "visible") {
    //     localStorage.getItem
    //   }
    // })
    // /*浏览器关闭、浏览器标签页关闭、浏览器刷新均会触发"beforeunload"事件*/
    // // window.addEventListener('beforeunload', e => this.handleFn())
  },
  beforeDestroy () {
    sessionStorage.clear();
  },
  methods: {
    startLoading() {
      loading = Loading.service({
        fullscreen: true,
        background: "rgba(0, 0, 0, 0)",
      });
    },
  },
};
</script>


<style lang="less">
#app {
  width: 100%;
  height: 100%;
}
</style>
